// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"842":"1e87e878a1bd4292","2059":"69fea1152e582b7c","9836":"71038f3fa6c04fc3"}[chunkId] + ".css";
};